export default __webpack_public_path__ + "static/media/linked_in.3c1d0239.svg";